export const TRAINING_SESSION_PARTICIPANT_UPDATE = {
    REQUEST: "TRAINING_SESSION_PARTICIPANT_UPDATE_REQUEST",
    SUCCESS: "TRAINING_SESSION_PARTICIPANT_UPDATE_SUCCESS",
    FAIL: "TRAINING_SESSION_PARTICIPANT_UPDATE_FAIL"
};